<template>
  <ag-card-container
    :title="company
      ? company.displayName
      : $t('general.loadingShort')"
    :search.sync="search"
    fluid
  >
    <template #left>
      <v-btn
        color="accent"
        small
        append
        to="add"
        v-text="$t('company.menu.addTokenButton')"
      />
    </template>

    <template #extension>
      <v-tabs :slider-size="0" slider-color="accent" grow>
        <v-tab
          :to="`/companies/${companyId}`"
          exact
          @click="search = ''"
          v-text="$t('company.menu.general')"
        />
        <v-tab
          :to="`/companies/${companyId}/demands`"
          exact
          @click="search = ''"
          v-text="$t('company.menu.demands')"
        />
        <v-tab
          :to="`/companies/${companyId}/history`"
          exact
          @click="search = ''"
          v-text="$t('company.menu.history')"
        />
        <v-tab
          :to="`/companies/${companyId}/users`"
          exact
          @click="search = ''"
          v-text="$t('company.menu.users')"
        />
      </v-tabs>
    </template>

    <router-view
      v-if="company"
      :search="search"
      :company.sync="company"
    />
  </ag-card-container>
</template>

<script>
import Repositories from 'src/repositories'
import { getRouteMeta } from 'src/router'

import AgCardContainer from 'src/components/common/AgCardContainer'

export default {
  name: 'CompanyContainer',
  components: {
    AgCardContainer,
  },
  props: {
    companyId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    search: '',
    company: null,
  }),
  watch: {
    $route: {
      immediate: true,
      async handler () {
        this.company = await Repositories.company.get(this.companyId)
        this.search = getRouteMeta(this.$route).search ? (this.search || '') : null
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.v-tab {
  &::before {
    opacity: 0.4 !important;
  }

  &:hover::before {
    opacity: 0.1 !important;
  }
}

.v-tab--active {
  &::before {
    opacity: 0.1 !important;
  }

  &:hover::before {
    opacity: 0.1 !important;
  }
}
</style>
